<template>
	<div class="product">
		<div class="search-order">
			<div class="el-search vue-top-padding radius">
				<el-row :gutter="20">
					<el-col :span="3">
						<div class="el-left">
							<el-button
								size="small"
								icon="el-icon-printer"
								@click="exportOrder"
								>{{ $t("common.export") }}</el-button
							>
						</div>
					</el-col>
					<el-col :span="21">
						<div class="el-right">
							<el-form
								ref="order"
								:model="search"
								:inline="true"
								label-width="10px"
								size="small"
								class="demo-form-inline el-input-height"
							>
								<el-form-item prop="dateTime">
									<el-date-picker
										v-model="dateTime"
										type="datetimerange"
										format="yyyy-MM-dd HH:mm:ss"
										value-format="yyyy-MM-dd HH:mm:ss"
										:picker-options="pickerOptions"
										range-separator="-"
										:start-placeholder="$t('searchOrder.start')"
										:end-placeholder="$t('searchOrder.end')"
									>
									</el-date-picker>
								</el-form-item>
								<el-form-item prop="equipmentNo">
									<el-input
										v-model="search.equipmentNo"
										:placeholder="$t('searchRenewalRecord.equipmentNo')"
									></el-input>
								</el-form-item>
								<el-form-item prop="serviceType">
									<el-select
										v-model="search.serviceType"
										:no-data-text="$t('common.noData')"
										:no-match-text="$t('common.noData')"
										clearable
										:placeholder="$t('waterRecord.serviceTypeHolder')"
									>
										<el-option
											v-for="item in serviceTypeList"
											:key="item.id"
											:label="item.label"
											:value="item.value"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button
										type="primary"
										@click="onSubmit"
										icon="el-icon-search"
										>{{ $t("common.search") }}</el-button
									>
									<el-button @click="resetSearch()" icon="el-icon-refresh">{{
										$t("common.reset")
									}}</el-button>
								</el-form-item>
							</el-form>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		<div class="vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="waterList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="username"
					:label="$t('user.userName')"
					width="200"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:label="$t('searchRenewalRecord.equipmentNo')"
					width="200"
					:align="'center'"
					:show-overflow-tooltip="true"
				></el-table-column>
				<el-table-column
					prop="price"
					:show-overflow-tooltip="true"
					:label="$t('waterRecord.price')"
					width="150"
					:align="'center'"
					:formatter="moneyMatter"
				></el-table-column>
				<el-table-column
					prop="info"
					:label="$t('waterRecord.detail')"
					:show-overflow-tooltip="true"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="type"
					:label="$t('waterRecord.serviceTypeHolder')"
					width="160"
					:align="'center'"
					:formatter="serviceTypes"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:label="$t('waterRecord.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="updateTime"
					:label="$t('waterRecord.updateDate')"
					width="160"
					:align="'center'"
				></el-table-column>
			</el-table>
			<el-pagination
				v-if="page.totalSize > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				@size-change="sizeChange"
				:page-size="page.pageSize"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	name: "Record",
	components: {},
	data() {
		return {
			serviceTypeList: [],
			dateTime: "",
			search: {
				equipmentNo: "",
				serviceType: "",
				startTime: "",
				endTime: "",
			},
			loading: false,
			page: {
				pageSize: 10,
				pageIndex: 1,
				totalSize: 0,
			},
			waterList: [],
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
		};
	},
	mounted() {
		this.getServiceType();
		this.currentChange();
	},
	methods: {
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		// 获取流水类型
		getServiceType() {
			this.$api.dict("service_type").then(res => {
				if (res.code === 0) {
					this.serviceTypeList = res.data;
				}
			});
		},
		// 格式化流水类型
		serviceTypes(row) {
			return this.$cloud.getDictLabel(this.serviceTypeList, row.type);
		},
		// 格式化金额
		moneyMatter(row) {
			// 截取当前数据到小数点后两位
			let realVal = "";
			if (row.price) {
				realVal = "$" + parseFloat(row.price).toFixed(2);
			}
			return realVal;
		},
		// 加载流水列表
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.myWallet.walletlog, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.waterList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 提交查询搜索
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.dateTime[0];
				this.search.endTime = this.dateTime[1];
			} else {
				this.search.startTime = "";
				this.search.endTime = "";
			}
			this.page.pageIndex = 1;
			this.currentChange();
		},
		// 重置条件
		resetSearch() {
			this.dateTime = "";
			this.search.equipmentNo = "";
			this.search.serviceType = "";
			this.search.startTime = "";
			this.search.endTime = "";
			this.currentChange();
		},
		// 导出账单
		exportOrder() {
			this.$confirm(this.$t("waterRecord.export"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					this.$api.download(this.$url.myWallet.export, this.search);
				})
				.catch(err => {
					this.$message.error(err.msg);
				});
		},
	},
};
</script>

<style scoped>
.el-tag--mini {
	margin-right: 5px;
}
</style>
